<template>
  <b-modal
    :id="id"
    ref="bModal"
    :qa="qaId"
    modal-class="modalConfirmation"
    centered
    ok-variant="-primary btn-sm"
    cancel-variant="-primary btn__outline btn-sm"
    :title="$tc('component.modalConfirmation.title')"
    :ok-title="okTitle"
    :cancel-title="cancelTitle"
    size="xs"
    :auto-focus-button="autoFocus"
    @ok="internalOnOk"
    @cancel="internalOnCancel"
    @hide="onHide"
  >
    <div
      class="px-3 secondary-color"
      v-html="message"
    />
    <b-form-checkbox
      v-if="checkable"
      v-model="dontShowAgainCheckStatus"
      :value="true"
      :unchecked-value="false"
    >
      <span class="confirmation-text">{{ dontShowAgainCheckableText }}</span>
    </b-form-checkbox>
  </b-modal>
</template>

<script>

export default {
    name: 'ModalConfirmation',
    props: {
        id: { type: String, required: true },
        content: { type: String },
        okTitle: { type: String, default: function() { return this.$tc('component.modalConfirmation.okTitle') } },
        cancelTitle: { type: String, default: function() { return this.$tc('component.modalConfirmation.cancelTitle') } },
        cancelOnHide: { type: Boolean, default: true },
        qaId: { type: String, default: 'confirmationModalGlobal' },
        checkable: { type: Boolean, default: false },
        dontShowAgainCheckableText: { type: String, default: function() { return this.$tc('component.modalConfirmation.dontShowAgain') } },
        autoFocus: { type: String, default: 'ok' }
    },
    data() {
        return {
            dontShowAgainCheckStatus: false,
            onOk: () => {},
            onCancel: () => {}
        }
    },
    computed: {
        message() {
            if (this.content) {
                return this.content
            }
            return this.$tc('component.modalConfirmation.content')
        }
    },
    methods: {
        internalOnOk() {
            this.onOk(this.dontShowAgainCheckStatus)
            this.$emit('ok')
        },
        internalOnCancel() {
            this.onCancel(this.dontShowAgainCheckStatus)
            this.$emit('cancel')
        },
        ask(onOk, onCancel) {
            this.onOk = onOk || (() => {})
            this.onCancel = onCancel || (() => {})
            this.$refs.bModal.show()
        },
        show() {
            this.dontShowAgainCheckStatus = false
            this.$refs.bModal.show()
        },
        onHide() {
            if (this.cancelOnHide) {
                this.internalOnCancel()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .confirmation-text {
        color: vt-color(dark-text);
    }
    .custom-control.custom-checkbox {
        margin-top: 10px;
    }
</style>
